export function moveItem<T>(fromIndex: number, toIndex: number, list: readonly T[]): T[] {
  const next = [...list]
  if (fromIndex < 0 || toIndex < 0 || fromIndex >= next.length || toIndex >= next.length || fromIndex === toIndex) {
    return next
  }
  const [item] = next.splice(fromIndex, 1)
  next.splice(toIndex, 0, item!)
  return next
}
